import { render } from "./App.vue?vue&type=template&id=51d67dae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=51d67dae&lang=css"

import exportComponent from "/Users/isamu/ss/misc-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__